import axios from 'axios';
import { ICuadroMetadatos, ICuadroMetadatosUso , ITotalizacion} from '@/services/cuadro/cuadro';
import AccessToken from '../accessToken.service';

export default class Cuadro {

    // clase que obtiene el token
    private accessToken = new AccessToken();

    public async ListarCuadroMetadatos(cuadro?: number): Promise<ICuadroMetadatos[] | undefined> {
        try {
            const api = process.env.VUE_APP_CUADRO_API + 'ListarCuadroMetadatos';            
            const config = {
                params: {
                    cuadro: cuadro,
                },
                headers: {
                    Authorization: `Bearer ${await this.accessToken.getAccessToken()}`,
                    Content: 'application/json; charset=utf-8',
                    responseType: "json"
                }
            };

            const result = await  axios.get(api, config);      
            if (result.data == null)
            {
                throw new Error('Valor nulo'); 
            }
            return result.data; 

        } catch (error) {
            throw new Error('API (Listar Cuadro Metadatos). ' + error) 
        }
    }

    public async ListarCuadroMetadatosUso(id_cuadro?: number): Promise<ICuadroMetadatosUso[] | undefined> {
        try {
            const api = process.env.VUE_APP_CUADRO_API + 'ListarCuadroMetadatosUso';
            const config = {
                params: {
                    id_cuadro: id_cuadro,
                },
                headers: {
                    Authorization: `Bearer ${await this.accessToken.getAccessToken()}`,
                    Content: 'application/json; charset=utf-8',
                    responseType: "json"
                }
            };

            const result = await axios.get(api, config);
            if (result.data == null) {
                throw new Error('Valor nulo');
            }
            return result.data;

        } catch (error) {
            throw new Error('API (Listar Series de Cuadro Metadatos ). ' + error)
        }
    }

    public async ConsultarCuadros(id_cuadro:number, fecha_inicio?:string, fecha_fin?:string) {
        try {
            const api = process.env.VUE_APP_CUADRO_API + 'ConsultarCuadros';
            
            const config = {
                params: {
                    id_cuadro : id_cuadro,
                    fecha_inicio: fecha_inicio,
                    fecha_fin: fecha_fin
                },
                headers: {
                    Authorization: `Bearer ${await this.accessToken.getAccessToken()}`,
                    Content: 'application/json; charset=utf-8',
                    responseType: "json"
                }
            };

            //console.table(config.params);

            const result = await  axios.get(api, config);      
            if (result.data == null)
            {
                throw new Error('Valor nulo'); 
            }
            //console.table(result.data);
            return result.data; 

        } catch (error) {
            throw new Error('API (Listar Consultar Cuadros). ' + error) 
        }
    }
    
    public async ConsultarCuadro(id_cuadro: number): Promise<[] | undefined> {
        try {

            const api = process.env.VUE_APP_CUADRO_API + 'ConsultarCuadro';
            const config = {
                    params: {
                        id_cuadro: id_cuadro
                    },
                    headers: {
                        Authorization: `Bearer ${await this.accessToken.getAccessToken()}`,
                        responseType: "json" 
                    }
                };        
            const result = await  axios.get(api, config);
            if (result.data == null)
            {
                throw new Error('Valor nulo'); 
            }
            
            return result.data; 

        } catch (error) {
            throw new Error('API (ConsultarCuadro). ' + error) 
        }
    }        
    
     // funciones de TOTALIZACION  ---------------------- 
    
     public async getCuadroUnidadMedidaOrigen(idCuadro:number) {
        try {
            const api = process.env.VUE_APP_CUADRO_API + 'ConsultarCuadroUnidadMedidaOrigen';
            const config = {
                params: {
                    id_cuadro : idCuadro
                },
                headers: {
                    Authorization: `Bearer ${await this.accessToken.getAccessToken()}`,
                    Content: 'application/json; charset=utf-8',
                    responseType: "json"
                }
            };

            const result = await  axios.get(api, config);    
            if (result.data == null)
            {
                throw new Error('Valor nulo'); 
            }
            // console.log(result.data);
            return result.data; 

        } catch (error) {
            throw new Error('API (Consultar la Unidad de medida origen). ' + error) 
        }
    }

    
    public async getCuadroUnidadMedidaDestino(idUnidadMedida:number) {
        try {
            const api = process.env.VUE_APP_CUADRO_API + 'ConsultarCuadroUnidadMedidaDestino';
            const config = {
                params: {
                    id_unidad_medida : idUnidadMedida
                },
                headers: {
                    Authorization: `Bearer ${await this.accessToken.getAccessToken()}`,
                    Content: 'application/json; charset=utf-8',
                    responseType: "json"
                }
            };

            const result = await  axios.get(api, config);    
            if (result.data == null)
            {
                throw new Error('Valor nulo'); 
            }
            // console.table(result.data);
            return result.data; 

        } catch (error) {
            throw new Error('API (Consultar la Unidad de medida). ' + error) 
        }
    }

    
    public async getPeriodicidadCuadro(idCuadro:number) {
        try {
            const api = process.env.VUE_APP_CUADRO_API + 'ConsultarPeriodicidadCuadro';
            const config = {
                params: {
                    id_cuadro : idCuadro
                },
                headers: {
                    Authorization: `Bearer ${await this.accessToken.getAccessToken()}`,
                    Content: 'application/json; charset=utf-8',
                    responseType: "json"
                }
            };

            const result = await  axios.get(api, config);    
            if (result.data == null)
            {
                throw new Error('Valor nulo'); 
            }
            //console.table(result.data);
            return result.data; 

        } catch (error) {
            throw new Error('API (Consultar la periodicidad). ' + error) 
        }
    }

    public async getTotalizacion(model:ITotalizacion): Promise<string[] | undefined> {
        try {
           const api = process.env.VUE_APP_CUADRO_API + 'ConsultarCuadrosTotalizacion';                      
           const config = {
              
               headers: {
                   Authorization: `Bearer ${await this.accessToken.getAccessToken()}`,
                   Content: 'application/json; charset=utf-8',
                   responseType: "json"
               }
           };
           const result = await  axios.post(api,model, config);            
           if (result.data == null)
           {
               throw new Error('Valor nulo'); 
           }   
           
           return result.data; 
   
       } catch (error) {
           throw new Error('API (Obtener totalización). ' + error)
       }
   }
    //-------------------------------------------


}
